var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', [_vm.isInitialLoad ? _c('tr', [_c('td', {
    staticClass: "empty-state-cell",
    attrs: {
      "colspan": "7"
    }
  }, [_c('div', {
    staticClass: "quick-date-btns-inline d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3"
  }, [_c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'all'
    },
    attrs: {
      "type": "button",
      "title": "All groups"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'all');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list me-1"
  }), _vm._v(" All Groups ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'today'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up today"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'today');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-day me-1"
  }), _vm._v(" Groups Today ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'week'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up this week"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'week');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-week me-1"
  }), _vm._v(" Groups This Week ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'month'
    },
    attrs: {
      "type": "button",
      "title": "Groups signed up this month"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'month');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt me-1"
  }), _vm._v(" Groups This Month ")])]), _vm._m(1)])]) : !_vm.rows.records || !_vm.rows.records.length ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._l(_vm.rows.records, function (row, index) {
    return _c('tr', {
      key: index,
      class: row.group_status.toLowerCase() == 'active' ? '' : 'inactive-row'
    }, [_c('td', [_c('span', [_vm._v(_vm._s(row.signup_date))]), _c('span', {
      class: row.group_status.toLowerCase() == 'active' ? 'id-status-active' : 'id-status-inactive'
    }, [_vm._v(_vm._s(row.group_status))]), _c('span', [_c('strong', [_vm._v("Code:")]), _vm._v(" " + _vm._s(row.group_code))])]), _c('td', [_c('h3', [_vm._v(_vm._s(row.group_name))]), _c('span', [_vm._v(_vm._s(row.group_contact_full_name))]), _c('span', [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(row.group_type) + " ")]), _c('span', [_c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(row.group_email) + " "), _c('valid-icon', {
      attrs: {
        "is-valid": row.is_email_valid,
        "className": "valid-icon"
      }
    })], 1), _c('span', [_c('strong', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(_vm.formatGroupPhone(row.group_phone)) + " "), _vm.formatGroupPhone(row.group_phone) != 'N/A' ? _c('valid-icon', {
      attrs: {
        "is-valid": row.is_phone_valid,
        "className": "valid-icon"
      }
    }) : _vm._e()], 1), _c('span', [_c('strong', [_vm._v("Web Url:")]), _vm._v(" " + _vm._s(row.group_web ? "/" + row.group_web : "N/A") + " ")]), row.is_plans_assigned ? _c('span', {
      staticClass: "mt-2"
    }, [_c('b', [_vm._v(" Plans Assigned ")]), _c('img', {
      staticStyle: {
        "width": "12px",
        "height": "12px",
        "margin-left": "4px"
      },
      attrs: {
        "src": require("@/assets/images/approved.png"),
        "alt": "Plans Assigned"
      }
    })]) : _vm._e()]), _c('td', [_c('span', [_c('strong', [_vm._v(" " + _vm._s(row.group_ga_agent_full_name ? row.group_ga_agent_full_name : "N/A") + " ")])]), _c('span', [_vm._v(" " + _vm._s(row.group_ga_agent_code ? row.group_ga_agent_code : "N/A") + " ")])]), _c('td', [_vm._v(_vm._s(row.location))]), _c('td', [_c('span', [_vm._v(_vm._s(row.estimate_number))]), _c('span', [_c('strong', [_vm._v("Industry:")]), _vm._v(" " + _vm._s(row.emp_industry))])]), _c('td', [_c('ul', [_c('li', [_c('strong', [_vm._v("A:")]), _vm._v(" " + _vm._s(row.active_total))]), _c('li', [_c('strong', [_vm._v("W:")]), _vm._v(" " + _vm._s(row.withdraw_total))]), _c('li', [_c('strong', [_vm._v("T:")]), _vm._v(" " + _vm._s(row.termed_total))]), _c('li', [_c('strong', [_vm._v("Totals:")]), _vm._v(" " + _vm._s(_vm.getStatTotal(row.active_total, row.withdraw_total, row.termed_total)) + " ")])]), _vm.getStatTotal(row.active_total, row.withdraw_total, row.termed_total) > 0 ? [_c('router-link', {
      staticClass: "viewClient-btn",
      attrs: {
        "to": {
          name: 'MemberListByGroup',
          params: {
            groupId: _vm.encodedId(row.group_id)
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" View Clients ")])] : _vm._e()], 2), _c('td', {
      staticClass: "action-btn-td"
    }, [_c('div', {
      staticClass: "action-btn"
    }, [_c('custom-route-button', {
      attrs: {
        "routeLink": {
          name: 'EmployerGroupPlans',
          params: {
            groupId: _vm.encodedId(row.group_id)
          }
        },
        "title": "Assign Plan",
        "iconClass": "fas fa-plus"
      }
    }), _c('custom-route-button', {
      attrs: {
        "routeLink": {
          name: 'EmployerGroupDetail',
          params: {
            groupId: _vm.encodedId(row.group_id)
          }
        },
        "title": "View/Edit Details",
        "iconClass": "fas fa-eye"
      }
    }), row.active_total + row.termed_total > 0 ? [_c('custom-button', {
      attrs: {
        "title": "Payment History",
        "iconClass": "fas fa-dollar-sign"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'payment-history-modal');
        }
      }
    }), _c('custom-button', {
      attrs: {
        "title": "View Invoice",
        "iconClass": "fas fa-file-invoice-dollar"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'download-invoice-modal');
        }
      }
    })] : _vm._e(), _c('custom-button', {
      attrs: {
        "title": "Assign Platforms",
        "iconClass": "fa-solid fa-handshake"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'view-domain-modal');
        }
      }
    }), _c('custom-button', {
      attrs: {
        "title": "Benefit Store",
        "iconClass": "fas fa-shopping-cart"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.toBenefitStore(row.group_id);
        }
      }
    }), row.actions.show_default_otp ? _c('custom-button', {
      attrs: {
        "title": "View Default OTP",
        "iconClass": "fas fa-list"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'defaultOtpModal');
        }
      }
    }) : _vm._e(), _c('custom-button', {
      attrs: {
        "title": "Send Group Enrollment",
        "iconClass": "fas fa-envelope"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openModal(row, 'send-group-enrollment-modal');
        }
      }
    }), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        value: _vm.ViewMsg,
        expression: "ViewMsg",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "custom-btn m-0",
      attrs: {
        "title": "View msg"
      },
      on: {
        "click": function click($event) {
          return _vm.routeToViewMessage(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/images/view-msg.svg")
      }
    })]), _c('custom-button', {
      attrs: {
        "title": "View Message",
        "imageSrc": require('@/assets/images/view-msg.svg')
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.routeToViewMessage(row);
        }
      }
    }), _vm.isVipUser && row.is_switchable ? _c('custom-button', {
      attrs: {
        "title": "Switch To Group Account",
        "iconClass": "fas fa-exchange-alt"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.switchToGroupRequest(row);
        }
      }
    }) : _vm._e(), row.actions.show_waive_button ? _c('custom-button', {
      attrs: {
        "title": "Waive Fee",
        "iconClass": "fas fa-money-bill-wave"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openWaiveFeeModal(row);
        }
      }
    }) : _vm._e(), row.actions.show_waive_button ? _c('custom-button', {
      attrs: {
        "title": "Waive Fee Logs",
        "iconClass": "fas fa-money-check-dollar"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openWaiveEfeeLogs(row);
        }
      }
    }) : _vm._e(), _vm.isVipUser && row.is_switchable ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "javascript:void(0);",
        "title": "Switch Logs"
      },
      on: {
        "click": function click($event) {
          return _vm.openLogModal(row.group_id);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/rep-logs.svg"),
        "width": "26px",
        "alt": ""
      }
    })]) : _vm._e(), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "javascript:void(0);",
        "title": "Add Notes"
      },
      on: {
        "click": function click($event) {
          return _vm.openAddNotesModal(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/add-notes-rounded.svg"),
        "width": "16px",
        "alt": "Add Employers/Group Notes"
      }
    })]), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      attrs: {
        "href": "javascript:void(0);",
        "title": "View Notes"
      },
      on: {
        "click": function click($event) {
          return _vm.openViewNotesModal(row);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/notes-bold.svg"),
        "width": "16px",
        "alt": "View Employers/Group Notes"
      }
    })]), _vm.isVipUser && row.is_switchable ? _c('custom-button', {
      attrs: {
        "title": "Switch To Group Account",
        "iconClass": "fas fa-exchange-alt"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.switchToGroupRequest(row);
        }
      }
    }) : _vm._e()], 2)])]);
  })], 2)]), _c('payment-history-modal', {
    attrs: {
      "row": _vm.row
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('download-invoice-modal', {
    attrs: {
      "row": _vm.row
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('default-otp-modal', {
    attrs: {
      "row": _vm.row,
      "rowType": "G"
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('send-group-enrollment', {
    attrs: {
      "row": _vm.row
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('view-domain-modal', {
    attrs: {
      "row": _vm.row,
      "allDomains": this.allDomains
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('WaiveEfeeModal', {
    attrs: {
      "show": _vm.showWaiveFeeModal,
      "row": _vm.row
    },
    on: {
      "onCloseModal": _vm.closeWaiveEfeeModal,
      "onSuccess": function onSuccess($event) {
        return _vm.$emit('refreshList');
      }
    }
  }), _c('WaiveEfeeLogs', {
    attrs: {
      "show": _vm.showWaiveEfeeLogs,
      "row": _vm.row,
      "type": 'group'
    },
    on: {
      "onCloseModal": _vm.closeWaiveEfeeLogs
    }
  }), _c('LogDisplayModal', {
    attrs: {
      "isOpen": _vm.isLogModalOpen,
      "logData": _vm.switchLogData,
      "userId": _vm.selectedGroupId,
      "logType": 'group'
    },
    on: {
      "update:isOpen": function updateIsOpen($event) {
        _vm.isLogModalOpen = $event;
      }
    }
  }), _c('add-notes-modal', {
    attrs: {
      "row": _vm.row,
      "isOpen": _vm.showAddNotesModal
    },
    on: {
      "close": function close($event) {
        _vm.showAddNotesModal = false;
      }
    }
  }), _c('view-notes-modal', {
    attrs: {
      "row": _vm.row,
      "isOpen": _vm.showViewNotesModal
    },
    on: {
      "close": function close($event) {
        _vm.showViewNotesModal = false;
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Signup Date")]), _c('th', [_vm._v("Group Name / Main Contact")]), _c('th', [_vm._v("Group GA")]), _c('th', [_vm._v("Location")]), _c('th', [_vm._v("Est. # of Employees / Industry")]), _c('th', [_vm._v("Totals")]), _c('th', [_vm._v("Actions")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty-state-msg"
  }, [_c('i', {
    staticClass: "fas fa-search me-2"
  }), _vm._v(" Enter search criteria or use a quick search above to display results. ")]);
}]

export { render, staticRenderFns }